import {
  IonButton, IonButtons, IonImg, IonLabel,
} from '@ionic/react';
import React, { useEffect } from 'react';

import CustomerFinishedImg from '@/assets/imgs/shipping-customer-finished.svg';
import { ManagedModalRoutes } from '@/interfaces/ManagedModalInterface/ManagedModalInterface';


import styles from './ShippingFinishedManaged.module.scss';

interface ShippingFinishedManageddProps {
  handleLoading: (e: boolean) => void;
  handleClose: () => void;
}

export default function ShippingFinishedManaged({
  handleLoading,
  handleClose,
}: ShippingFinishedManageddProps) {
  const handleContinue = async () => {
    handleClose();
  };

  return (
    <div className={styles.shippingFinishedManagedWrapper}>
      <div className={styles.shippingFinishedManagedTitleDescriptionWrapper}>
        <div className={styles.shippingFinishedManagedTitleWrapper}>
          <IonLabel className={styles.modalShippingFinishedManagedTitle}>¡Estupendo!</IonLabel>
        </div>
        <div className={styles.shippingFinishedManagedTitleWrapper}>
          <IonLabel className={styles.modalShippingFinishedManagedDescription}>
            Ya hemos enviado el enlace al cliente para que pueda continuar con el proceso
          </IonLabel>
        </div>
      </div>
      <div className={styles.shippingFinishedManagedImgWrapper}>
        <IonImg src={CustomerFinishedImg} />
      </div>
      <IonButtons className={styles.nextBtnWrapper}>
        <IonButton className="nextButton" onClick={handleContinue} disabled={false}>Terminar</IonButton>
      </IonButtons>
    </div>
  );
}
